import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logoutUser } from '../LoginPage/action';

const mapDispatchToProps = dispatch => ({
    logoutUser: bindActionCreators(logoutUser, dispatch),
});

class LogoutPage extends React.Component {
    componentWillMount() {
        this.props.logoutUser();
    }

    render() {
        return <div />;
    }
}

export default connect(
    null,
    mapDispatchToProps
)(LogoutPage);



// WEBPACK FOOTER //
// ./app/web/src/container/LogoutPage/index.jsx